import { ClassNames } from "@emotion/react";
import { Box, Modal, TextField, useMediaQuery, useTheme } from "@mui/material";
import React, { FC, useEffect, useState } from "react";
import classes from "./AddOutsourcingMailModal.module.scss";
import { useGetWorkerInfo } from "../../../../hooks/api/workers/useGetWorkerInfo";
import SelectBoxForFactory from "../../../uikit/molecules/selectboxes/SelectBoxForFactory";
import SelectBoxForNumber from "../../../uikit/atoms/selectboxes/SelectBoxForNumber";
import { factoriesForInput } from "../../../../utils/variables/factoriesForInupt";
import { userState } from "../../../../states/userState";
import { useRecoilState } from "recoil";
import { AddressInfoType, User } from "../../../../types";
import { setUserToLocalStorage } from "../../../../utils/functions/localStorageManager";
import { Buttons } from "../../../uikit/atoms/buttons/Buttons";
import CircularProgress from "@mui/material/CircularProgress";
//保存
import SaveIcon from "@mui/icons-material/Save";
//キャンセル
import CancelIcon from "@mui/icons-material/Cancel";
import { WithIconButton } from "../../../uikit/atoms/buttons/WithIconButton";
import { useAddAddress } from "../../../../hooks/api/address/useAddAddress";

type Props = {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  getAddressList: (address: string, factoryId: string) => Promise<any>;
  setAddressList: React.Dispatch<React.SetStateAction<AddressInfoType[]>>;
};

const defaultWorkerInfo = {
  workerId: "",
  workerName: "",
  departmentId: null,
  departmentName: null,
  place: null,
};
const AddOutsourcingMailModal: FC<Props> = (props) => {
  const { open, setOpen, getAddressList, setAddressList } = props;
  const [user, setUser] = useRecoilState<User>(userState);
  const theme = useTheme();
  const [factoryId, setFactoryId] = useState(
    user.initialParameters.factoryNoForOutsourcingTo === 0
      ? 50
      : user.initialParameters.factoryNoForOutsourcingTo
  );
  const isIphone = useMediaQuery(theme.breakpoints.down("sm"));
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const isNotePc = useMediaQuery(theme.breakpoints.down("lg"));
  const [workerInfo, setWorkerInfo] = useState(defaultWorkerInfo);
  const [saveIsDisabled, setIsSaveDisabled] = useState(true);
  const { addToAddress } = useAddAddress();
  const [errorWorkerName, setErrorWorkerName] = useState({
    isShow: true,
    text: "必須",
  });
  const [errorAddress, setErrorAddress] = useState({
    isShow: true,
    text: "必須",
  });
  const [address, setAddress] = useState("");
  const getWorkerInfo = useGetWorkerInfo();
  //社員番号入力
  const handleChangeWorkerId = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.value.length <= 5) {
      setWorkerInfo((prevState) => ({
        ...prevState,
        workerId: e.target.value,
      }));
      if (e.target.value.length === 0) {
        setErrorWorkerName({ isShow: true, text: "未設定" });
      } else {
        setErrorWorkerName({ isShow: false, text: "" });
      }
      // setErrorWorkerName({ isShow: true, text: "未設定" });
    }
  };
  const handleFocusWorkerId = () => {
    // console.log("Field is focused");
    setWorkerInfo((prevState) => ({
      ...prevState,
      workerId: "",
      workerName: "",
      departmentId: null,
      departmentName: null,
      place: null,
    }));
    setErrorWorkerName({ isShow: true, text: "未設定" });
  };
  const onSearch = async () => {
    // console.log("Field has lost focus");
    if (workerInfo.workerId.length > 0) {
      const res = await getWorkerInfo(workerInfo.workerId);
      // console.log(res);
      if (res) {
        setWorkerInfo((prevState) => ({
          ...prevState,
          workerId: res[5],
          workerName: res[0],
          departmentId: res[1],
          departmentName: res[6],
          place: res[3],
        }));
        // 社員番号が登録されているか確認
        try {
          const isRegistered = await getAddressList(res[5], "");
          if (isRegistered && isRegistered.length > 0) {
            setErrorWorkerName({
              isShow: true,
              text: "登録済です",
            });
          } else {
            setErrorWorkerName({ isShow: false, text: "" });
          }
        } catch (error) {
          setErrorWorkerName({
            isShow: true,
            text: "エラー発生",
          });
        }
      } else {
        setWorkerInfo(defaultWorkerInfo);
        setErrorWorkerName({ isShow: true, text: "見つかりません" });
      }
    }
  };
  //工場番号入力
  const handleFactoryChange = (e: number) => {
    setFactoryId(e);
    // setDiaryList((prevState) =>
    //   prevState.map((diary) => {
    //     if (diary.id === id) {
    //       return { ...diary, factoryId: e };
    //     }
    //     return diary;
    //   })
    // );

    setUser((prevUser: User) => {
      const newUser: User = {
        ...prevUser,
        initialParameters: {
          ...prevUser.initialParameters,
          factoryNoForOutsourcingTo: e,
        },
      };
      setUserToLocalStorage(newUser);
      return newUser;
    });
  };
  //メールアドレス入力
  const handleChangeAddress = (e: React.ChangeEvent<HTMLInputElement>) => {
    setAddress(e.target.value);
    if (e.target.value.length === 0) {
      setErrorAddress({ isShow: true, text: "必須" });
    } else {
      setErrorAddress({ isShow: false, text: "" });
    }
    // setErrorWorkerName({ isShow: true, text: "未設定" });
  };
  const handleFocusAddress = () => {
    // consoAddresseld is focused");
    setAddress("");
    setErrorAddress({ isShow: true, text: "必須" });
  };
  const onValidateAddress = async () => {
    if (address.length === 0) {
      setErrorAddress({ isShow: true, text: "必須" });
      return;
    }

    // メールアドレスの形式を検証
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(address)) {
      setErrorAddress({ isShow: true, text: "無効なメールアドレスです" });
      return;
    }
  };

  // 保存ボタンの有効/無効を管理
  useEffect(() => {
    const isWorkerValid =
      workerInfo.workerId.length > 0 && !errorWorkerName.isShow;
    const isAddressValid = address.length > 0 && !errorAddress.isShow;
    setIsSaveDisabled(!(isWorkerValid && isAddressValid));
  }, [
    workerInfo.workerId,
    errorWorkerName.isShow,
    address,
    errorAddress.isShow,
  ]);

  const handleSaveButtonClick = async () => {
    const postData: AddressInfoType = {
      workerId: workerInfo.workerId,
      address: address,
      factoryId: factoryId,
      factoryName:
        factoriesForInput.find((factory) => factory.id === factoryId)?.name ||
        "",
      workerName: workerInfo.workerName,
      updateUser: user.mail as string,
      createdAt: "",
      updatedAt: "",
      isSelected: false,
    };
    console.log({ postData });
    try {
      await addToAddress(postData);
      const res = await getAddressList("", "");
      setAddressList(res);
    } catch (errer) {
      window.alert("エラーが発生しました" + errer);
    } finally {
      setOpen(false);
    }
  };
  return (
    <Modal
      open={open}
      onClose={() => setOpen(false)}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      sx={{
        borderColor: theme.palette.foreColor.main,
        border: "none",
        "&:focus-visible": {
          borderColor: theme.palette.foreColor.main,
          outlineColor: theme.palette.foreColor.main, // Assuming your theme's primary.main is the color you want
        },
        // zIndex: 100,
      }}
    >
      <Box
        sx={{
          backgroundColor: theme.palette.backColor.main,
          display: "flex",
          flexDirection: "column",
          //   flexGrow: 1,
          //   width: "100%",
          width: isIphone
            ? "375px"
            : isMobile
            ? "375px"
            : isNotePc
            ? "375px"
            : "375px",
          position: "absolute",
          borderRadius: "5px",
          padding: "20px",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          height: isIphone
            ? "360px"
            : isMobile
            ? "360px"
            : isNotePc
            ? "360px"
            : "360px",
        }}
      >
        <div className={classes.titleArea}>
          <p>宛先メールアドレス追加</p>
        </div>
        <div className={classes.firstLine}>
          <div className={classes.workerArea}>
            <TextField
              helperText={errorWorkerName.text}
              error={errorWorkerName.isShow}
              label="社員番号"
              variant="standard"
              type="number"
              multiline={false}
              value={workerInfo.workerId}
              sx={{
                height: "70px",
                width: "100px",
                overflow: "hidden",
                whiteSpace: "nowrap",
                textOverflow: "ellipsis",
                //スピンボタンの無効化-効いていない
                ':global(input[type="number"]::-webkit-outer-spin-button)': {
                  WebkitAppearance: "none",
                  margin: 0,
                },
                ':global(input[type="number"]::-webkit-inner-spin-button)': {
                  WebkitAppearance: "none",
                  margin: 0,
                },

                "& .MuiInputBase-input": {
                  color: theme.palette.foreColor.main, // テキストフィールド内のフォントカラーをプライマリーカラーに
                  fontSize: "16px",
                  // その他のスタイル設定...
                },
                "& label": {
                  color: theme.palette.foreColor.main, // 通常時のラベル色
                  //backgroundColor:"white"
                },
                "& label.Mui-focused": {
                  color: theme.palette.foreColor.main, // ラベルの色をprimary.mainに指定
                },
                "& .MuiInput-underline:before": {
                  borderBottomColor: theme.palette.foreColor.main, // 通常時のボーダー色
                },
                "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
                  borderBottomColor: theme.palette.foreColor.main, // ホバー時のボーダー色
                },
                "& .MuiOutlinedInput-root": {
                  "& fieldset": {
                    borderColor: theme.palette.foreColor.main, // 通常時のボーダー色(アウトライン)
                  },
                  "&:hover fieldset": {
                    borderColor: theme.palette.foreColor.main, // ホバー時のボーダー色(アウトライン)
                  },
                  "& .MuiInputBase-root": {},
                },
              }}
              onChange={handleChangeWorkerId}
              onFocus={handleFocusWorkerId}
              onBlur={onSearch}
              placeholder="1234or01234"
              InputLabelProps={{
                shrink: true,
              }}
            />
            <div className={classes.workerInfo}>
              <p>{workerInfo.departmentName}</p>
              <p>{workerInfo.workerName}</p>
            </div>
          </div>
          <div className={classes.factoryArea}>
            <p>登録工場</p>
            <SelectBoxForNumber
              label={""}
              options={factoriesForInput}
              required={true}
              select={handleFactoryChange}
              value={factoryId}
              disabled={false}
              width={"85px"}
              height={"38px"}
              fontSize={"12px"}
              colorMode={"dark"}
              setMode={"input"}
            />
          </div>
        </div>
        <div className={classes.secondLine}>
          <TextField
            helperText={errorAddress.text}
            error={errorAddress.isShow}
            label="メールアドレス"
            variant="standard"
            type="email"
            multiline={false}
            value={address}
            sx={{
              height: "70px",
              width: "240px",
              overflow: "hidden",
              whiteSpace: "nowrap",
              textOverflow: "ellipsis",
              //スピンボタンの無効化-効いていない
              ':global(input[type="number"]::-webkit-outer-spin-button)': {
                WebkitAppearance: "none",
                margin: 0,
              },
              ':global(input[type="number"]::-webkit-inner-spin-button)': {
                WebkitAppearance: "none",
                margin: 0,
              },

              "& .MuiInputBase-input": {
                color: theme.palette.foreColor.main, // テキストフィールド内のフォントカラーをプライマリーカラーに
                fontSize: "16px",
                // その他のスタイル設定...
              },
              "& label": {
                color: theme.palette.foreColor.main, // 通常時のラベル色
                //backgroundColor:"white"
              },
              "& label.Mui-focused": {
                color: theme.palette.foreColor.main, // ラベルの色をprimary.mainに指定
              },
              "& .MuiInput-underline:before": {
                borderBottomColor: theme.palette.foreColor.main, // 通常時のボーダー色
              },
              "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
                borderBottomColor: theme.palette.foreColor.main, // ホバー時のボーダー色
              },
              "& .MuiOutlinedInput-root": {
                "& fieldset": {
                  borderColor: theme.palette.foreColor.main, // 通常時のボーダー色(アウトライン)
                },
                "&:hover fieldset": {
                  borderColor: theme.palette.foreColor.main, // ホバー時のボーダー色(アウトライン)
                },
                "& .MuiInputBase-root": {},
              },
            }}
            onChange={handleChangeAddress}
            onFocus={handleFocusAddress}
            onBlur={onValidateAddress}
            placeholder="example@gmail.com"
            InputLabelProps={{
              shrink: true,
            }}
          />
        </div>
        <div className={classes.thirdLine}>
          <div>
            <WithIconButton
              disabled={saveIsDisabled}
              onClick={handleSaveButtonClick}
              width={100}
              height={32}
              fontSize={16}
              icon={<SaveIcon />}
              label={"追加"}
            />
          </div>
          <div>
            <WithIconButton
              disabled={false}
              onClick={() => setOpen(false)}
              width={100}
              height={32}
              fontSize={12}
              icon={<CancelIcon />}
              label={"キャンセル"}
              backgroundColor={"#eaebe6"}
              color={"#535353"}
            />
          </div>
        </div>
      </Box>
    </Modal>
  );
};

export default AddOutsourcingMailModal;
